import { ChoiceGroup, IChoiceGroupOption, PersonaSize } from "@fluentui/react"
import { useMemo } from "react"
import { getProviderPosition } from "./Util"
import PodPlaceholder from "./PodPlaceholder"
import PodPersona from "./PodPersona"
import styles from './PodProviderSelector.module.scss'
import { ProviderOption } from "./state/reducer"

interface Props {
  options: ProviderOption[],
  selectedKey: string | null,
  onChange: (key: string) => void,
  disabled?: boolean,
}

const PodProviderSelector = ({options, selectedKey, onChange, disabled}: Props) => {

  const opts: IChoiceGroupOption[] = useMemo(() => {
    return options.map(provider => ({
      key: provider.id,
      text: provider.fullName,
      onRenderField: (props, render) => (
        <div
          className={`${styles.option}${props?.checked ? ` ${styles.selected}` : ''}${props?.disabled ? ` ${styles.disabled}` : ''}`}
          onClick={(e) => {
            e.preventDefault();
            if (!props?.disabled) props?.onChange!(e, props);
          }}
        >
          <div className={styles.persona}>
            <PodPersona provider={provider} secondaryText={getProviderPosition(provider) ?? ''} size={PersonaSize.size40} />
          </div>
          <div className={styles.radioButton}>
            {render!(props)}
          </div>
        </div>
      ),
      onRenderLabel: () => null,
    }));
  }, [options]);

  if (opts.length === 0) {
    return <PodPlaceholder full iconName="Search" text="No providers found" />
  }

  return (
    <ChoiceGroup
      disabled={disabled}
      className={styles.choiceGroup}
      options={opts}
      selectedKey={selectedKey}
      onChange={(_, props) => onChange(props!.key)}
    />
  )
};

export default PodProviderSelector;